<template>
  <div class="popup__content">
    <div v-if="!isCompleteRequest" class="step__request">
      <div class="content">
        <i class="icon icon--reset-password"></i>
        <strong class="title-reset">{{ $t('account.resetPassword.title') }}</strong>
        <div class="input--wrap">
          <form @submit.prevent="onSubmit">
            <div class="inner__input">
              <label for="email" class="text-email">{{ $t('common.id') }}</label>
              <input type="text"
                     id="email"
                     class="tf-email"
                     :placeholder="$t('common.validationErrorText.requiredId')"
                     :class="{error: modelError.userId}"
                     @focus="modelError.userId = null"
                     v-model.trim="model.userId">
              <i v-if="model.userId.length" class="icon icon--close14" @click="model.userId = ''"></i>
              <strong v-if="modelError.userId" class="validation-text">
                {{ $t(`common.validationErrorText.${modelError.userId}`) }}
              </strong>
            </div>
            <div class="btn--wrap">
              <ui-button class="btn-item" :buttonType="'reset'" @click="onCloseLayer">
                {{ $t('common.cancel') }}
              </ui-button>
              <ui-button class="btn-confirm" :buttonType="'submit'" :primary="true">
                {{ $t('common.confirm') }}
              </ui-button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else class="step__complete">
      <div class="content">
        <i class="icon icon--mail"></i>
        <strong class="title-reset">{{ $t('account.resetPassword.request.requestSuccess.title') }}</strong>
        <p class="text-desc" v-html="$t('account.resetPassword.request.requestSuccess.desc')"></p>
        <div class="btn--wrap">
          <ui-button class="btn-confirm" @click="onCloseLayer">
            {{ $t('common.confirm') }}
          </ui-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import { findPassword } from '@/api/user'

export default {
  components: {
    UiButton
  },
  data () {
    return {
      isCompleteRequest: false,
      model: {
        userId: ''
      },
      modelError: {
        userId: null
      }
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    onSubmit () {
      if (!this.model.userId.length) {
        this.modelError.userId = 'requiredId'
        return false
      }

      findPassword(this.model).then(() => {
        this.isCompleteRequest = true
      }).catch(err => {
        if (err.message === 'Not found user') {
          this.modelError.userId = 'notFoundEmail'
        } else if (err.message === 'Unactivated user') {
          this.modelError.userId = 'unActivatedEmail'
        } else if (err.message === 'Pending user') {
          this.modelError.userId = 'unApprovedId'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup__content {
  @include positionXYcenter;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 50px 30px 25px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  .step__request .btn-confirm {
    margin-left: 5px;
  }

  .title-reset {
    display: block;
    padding-top: 15px;
    font-size: 20px;
    line-height: 23px;
    color: #444;
  }
  .text-desc {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
  }
  .input--wrap {
    width: 100%;
    padding-top: 25px;
    .text-email {
      display: block;
      padding-left: 5px;
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .inner__input {
      position: relative;
      margin-top: 5px;

      .tf-email {
        margin-top: 5px;
        border-radius: 6px;
        border: solid 1px #bbb;
        display: block;
        width: 100%;
        height: 36px;
        padding: 0 12px;
        box-sizing: border-box;
        background-color: transparent;

        &.error {
          border-color: $errorColor;
        }
      }
      .icon--close14 {
        position: absolute;
        top: calc(50% - 6px);
        right: 2px;
        padding: 9px 12px;
        background-position: center;
        background-color: transparent;
      }
    }
    .btn--wrap {
      margin-top: 40px;
      button {
        min-width: 86px;
      }
    }
  }

  .step__complete {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;

    .btn--wrap {
      margin-top: 30px;
    }
  }

  .validation-text {
    @include validErrorText;
    position: absolute;
    left: 6px;
    bottom: -20px;
  }
}
</style>
